import React, { useEffect, useState } from 'react'
import { Card, Table } from '@themesberg/react-bootstrap'
import { getAllChannel } from '../../../../controller/api/__loto__/channel';
import { useCookies } from 'react-cookie';

const parseWeekdayName = (day) => {
  switch (day) {
    case 'Mon':
      return 'Thứ hai'
    case 'Tue':
      return 'Thứ ba'
    case 'Wed':
      return 'Thứ tư'
    case 'Thu':
      return 'Thứ năm'
    case 'Fri':
      return 'Thứ sáu'
    case 'Sat':
      return 'Thứ bảy'
    case 'Sun':
      return 'Chủ nhật'
    default:
      return ''
  }
}

const RULE_SET_LABELS = {
  SET_A: 'Tây Ninh',
  SET_B: 'Bến Tre',
  SET_KG: 'Kiên Giang',
}

const TableRow = ({ weekday, channels }) => {
  return (
    <tr>
      <td className="align-middle">{parseWeekdayName(weekday)}</td>
      <td>
        {(channels || []).map(channel => (
          <div key={channel.id}>
            <strong className="text-danger">{channel.id}</strong>
            <span className="ms-2">{channel.name || ''}</span>
          </div>
        ))}
      </td>
    </tr>
  );
};

export const ChannelTable = ({ region }) => {

  const [schedule, setSchedule] = useState({ ruleSet: '', data: [] })

  const [cookies] = useCookies(['lottmekong'])

  useEffect(() => {
    const load = async () => {
      const list = await getAllChannel(cookies.lottmekong)

      if (list) {
        setSchedule({
          ruleSet: list.ruleSet || '',
          data: Array.isArray(list.data) ? list.data : [],
        })
      }
    }
    load()
  }, [cookies.lottmekong, region])

  const rows = schedule.data.filter(day => (day.channels || []).length > 0)
  const ruleSetLabel = RULE_SET_LABELS[schedule.ruleSet] || schedule.ruleSet

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <h6 className="mb-0">Danh sách đài</h6>
          <div className="small text-muted mt-1">
            Bộ luật đang dùng: {ruleSetLabel || 'Đang tải...'}
          </div>
        </Card.Header>
        <Table responsive className="align-items-center table-flush">
          <thead className="thead-light">
            <tr>
              <th scope="col">Thứ</th>
              <th scope="col">Đài</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(day => <TableRow key={day.weekday} weekday={day.weekday} channels={day.channels} />)}
          </tbody>
        </Table>
      </Card>
    </>
  );
};